/* @flow */

import {DOWNLOAD_CONTROLLER_USER_SOURCE, LOGGED_OUT_CAMPAIGN_WORKFLOWS} from '../../../../constants/AppPicker/appPickerConstants';
import DeviceDetectionUtil from '../../../../utils/DeviceDetectionUtil';
import CompatibilityUtil from '../../../../utils/CompatibilityUtil';
import Url from '../../../../utils/Url';
import CCDUtil from '../../../../utils/CCDUtil';

export const WORKFLOWS = {
	KAIZEN: 'kaizen',
	THOR: 'thor',
	INCOMPATIBLE: 'incompatible'
};

export const getHeadingTextId = (workflow: string, source: string, sapCode: string) => {
	switch (workflow) {
		case WORKFLOWS.KAIZEN:
			switch (source) {
				case DOWNLOAD_CONTROLLER_USER_SOURCE.LOGGED_OUT_CAMPAIGN_PAGE:
					if (
						Url.getParam('workflow') === LOGGED_OUT_CAMPAIGN_WORKFLOWS.OPEN_FILE
						&& Url.getParam('file')
					) {
						return 'apps.loggedOutCampaign.kaizen.openFile.title';
					}
					return 'apps.loggedOutCampaign.kaizen.title';
				case DOWNLOAD_CONTROLLER_USER_SOURCE.SINGLE_APP_POST_PURCHASE_PAGE:
					if (sapCode === 'KCCC') {
						return 'apps.allAppsAppPicker.kaizen.title';
					}
					return 'apps.singleAppPostPurchase.kaizen.title';
				default:
					return 'apps.allAppsAppPicker.kaizen.title';
			}
		case WORKFLOWS.THOR:
			if (sapCode === 'KCCC') {
				return 'apps.allAppsAppPicker.thor.kccc.title';
			}
			switch (source) {
				case DOWNLOAD_CONTROLLER_USER_SOURCE.LOGGED_OUT_CAMPAIGN_PAGE:
					if (Url.getParam('workflow') === LOGGED_OUT_CAMPAIGN_WORKFLOWS.OPEN_FILE) {
						return 'apps.loggedOutCampaign.thor.openFile.title';
					}
					return 'apps.loggedOutCampaign.thor.title';
				case DOWNLOAD_CONTROLLER_USER_SOURCE.SINGLE_APP_POST_PURCHASE_PAGE:
					return 'apps.singleAppPostPurchase.thor.title';
				default:
					return 'apps.allAppsAppPicker.thor.title';
			}
		case WORKFLOWS.INCOMPATIBLE:
			if (source === DOWNLOAD_CONTROLLER_USER_SOURCE.LOGGED_OUT_CAMPAIGN_PAGE) {
				return 'apps.loggedOutCampaign.incompatible.title';
			}
			return 'apps.download.incompatible.heading';
	}
};

const _getBrowserStringPrefix = (hasThor: ?boolean) => {
	if (DeviceDetectionUtil.isChrome()) {
		return 'body_chrome';
	}
	else if (DeviceDetectionUtil.isSafari()) {
		return 'body_safari';
	}
	else if (DeviceDetectionUtil.isFirefox()) {
		return 'body_firefox';
	}
	else if (DeviceDetectionUtil.isEdge()) {
		return hasThor ? 'body' : 'body_edge';
	}
	else if (DeviceDetectionUtil.isInternetExplorer()) {
		return 'body_ie';
	}
	return 'body';
};

export const getBodyTextId = (workflow: string, source: string, sapCode: string, hasThor: ?boolean) => {
	switch (workflow) {
		case WORKFLOWS.KAIZEN: {
			let bodyString = 'apps.allAppsAppPicker.kaizen';
			if (source === DOWNLOAD_CONTROLLER_USER_SOURCE.SINGLE_APP_POST_PURCHASE_PAGE) {
				if (['APRO', 'SPRK'].includes(sapCode)) {
					bodyString = 'apps.singleAppPostPurchase.kaizen.acrobat-xd';
				}
			}
			if (
				source === DOWNLOAD_CONTROLLER_USER_SOURCE.LOGGED_OUT_CAMPAIGN_PAGE
				&& Url.getParam('workflow') === LOGGED_OUT_CAMPAIGN_WORKFLOWS.OPEN_FILE
				&& Url.getParam('file')
				&& sapCode !== 'KCCC'
			) {
				return 'apps.loggedOutCampaign.kaizen.openFile.body';
			}
			if (sapCode === 'KCCC') {
				bodyString = 'apps.singleAppPostPurchase.kaizen.ccd';
			}
			return `${bodyString}.${_getBrowserStringPrefix(hasThor)}`;
		}

		case WORKFLOWS.THOR: {
			// Return empty string in route to path campaign experience
			if (CCDUtil.isRouteToPathCampaign()) {
				return '';
			}
			let bodyString = 'apps.allAppsAppPicker.thor';
			if (source === DOWNLOAD_CONTROLLER_USER_SOURCE.SINGLE_APP_POST_PURCHASE_PAGE && sapCode === 'KCCC') {
				bodyString = 'apps.singleAppPostPurchase.thor';
			}
			else if (source === DOWNLOAD_CONTROLLER_USER_SOURCE.LOGGED_OUT_CAMPAIGN_PAGE && sapCode !== 'KCCC') {
				if (Url.getParam('workflow') === LOGGED_OUT_CAMPAIGN_WORKFLOWS.OPEN_FILE) {
					return 'apps.loggedOutCampaign.thor.openFile.body';
				}
				bodyString = 'apps.loggedOutCampaign.thor';
			}
			if (sapCode === 'KCCC') {
				bodyString = `${bodyString}.kccc`;
			}
			return `${bodyString}.${_getBrowserStringPrefix(hasThor)}`;
		}
		
		case WORKFLOWS.INCOMPATIBLE: {
			if (source === DOWNLOAD_CONTROLLER_USER_SOURCE.LOGGED_OUT_CAMPAIGN_PAGE) {
				return 'apps.loggedOutCampaign.incompatible.desc';
			}
			else if (source === DOWNLOAD_CONTROLLER_USER_SOURCE.SINGLE_APP_POST_PURCHASE_PAGE) {
				let subHeadingIdPrefix = 'kaizen';
				if (!CompatibilityUtil.isAppSupported('KCCC')) {
					subHeadingIdPrefix = 'thor';
				}
				else if (hasThor) {
					if (CompatibilityUtil.isCCDSupported()) {
						subHeadingIdPrefix = 'ccd';
					}
					else {
						subHeadingIdPrefix = 'thor';
					}
				}
				return `apps.download.incompatible.subHeading.${subHeadingIdPrefix}`;
			}
		}
	}
};